import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import { TextBox } from 'components/form/TextBox';
import { DropDown } from 'components/form/DropDown';
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup';
import { Button } from 'components/form/Button';
import { ReactComponent as HideFilter } from 'style/icons/art-hide-filters.svg';
import { ReactComponent as ShowFilter } from 'style/icons/art-show-filters.svg';

const LifeInsuranceFilter = props => {
  const {
    states,
    datatestid,
    typeOfCoverage,
    amountOfCoverage,
    checkBoxList,
    onSelectMultiQuestionOptions,
    pagePosition,
    onLifeInsuranceSearch,
    handleShowFilters,
    handleFilterValue,
  } = props;

  return (
    <Row className="margT0 margB24">
      <FlexContainer className="align-items-center m-flex-column justify-between width100">
        <FlexContainer className="format60 m-format100 flex-container m-flex-column">
          <TextBox
            id={`${props?.module}-zip`}
            name="zip"
            datatestid={`${datatestid}-zipCode`}
            placeholder="Zip code"
            value={states.zipCode}
            onChange={e => handleFilterValue(e.target.value, 'zipCode')}
            outerClassName={'margR16 m-margT16 zipLabel'}
            maxLength={5}
            aria-label={`${props?.module}-zipCode`}
          />

          <DropDown
            id="current-coverage-type"
            datatestid={`${datatestid}-current-coverage-type`}
            list={typeOfCoverage}
            value={states.currentCoverageType}
            onChange={e => handleFilterValue(e, 'currentCoverageType')}
            label={'Type of Coverage'}
            placeholder={'Type of Coverage'}
            isValueLabelBased={true}
            outerClassName={'margR16'}
          />
          <DropDown
            id="current-coverage-amount"
            datatestid={`${datatestid}-current-overage-amount`}
            list={amountOfCoverage}
            value={states.currentCoverageAmount}
            onChange={e => handleFilterValue(e, 'currentCoverageAmount')}
            label={'Amount of Coverage'}
            placeholder={'Amount of Coverage'}
            isValueLabelBased={true}
          />
        </FlexContainer>

        <FlexContainer className="format40 m-format100 align-items-center m-flex-column m-margT28">
          <FlexContainer className="format100">
            <CheckboxGroup
              type="checkbox"
              initialText="User Status"
              options={checkBoxList}
              values={states.multiChoiceAnswers}
              onChange={onSelectMultiQuestionOptions}
              datatestid={`${datatestid}-checkbox-group`}
              pagePosition={pagePosition}
              toolTipClassName="tooltip"
            />
          </FlexContainer>

          <Button
            datatestid={`${datatestid}-auto-life-offer-get`}
            mrphType="primary"
            onClick={onLifeInsuranceSearch}
            className="border-rad100px m-margT24 margL20 m-margL0"
          >
            Update
          </Button>
          <Row className="text-center m-margT16 d-hide">
            <Label
              type="caption"
              color="secondary_text_light"
              className="text-center m-margB8"
              bold
              datatestid={datatestid ? `${datatestid}-hideFilter` : null}
            >
              <span
                className="pointer m-text-14"
                onClick={handleShowFilters}
                data-testid="aiHideFilter"
              >
                Hide Filters
                <HideFilter />
              </span>
            </Label>
          </Row>
        </FlexContainer>
      </FlexContainer>
    </Row>
  );
};

const LifeInsuranceFilters = props => {
  const { states, handleShowFilters, datatestid } = props;

  return states.showFilters ? (
    <LifeInsuranceFilter {...props} />
  ) : (
    <Row className="text-center m-margT16 d-hide m-margB20">
      <Label
        type="caption"
        color="secondary_text_light"
        className="text-center"
        bold
        datatestid={datatestid ? `${datatestid}-hideFilter` : null}
      >
        <span
          className="pointer t-text-16"
          onClick={handleShowFilters}
          data-testid="liHideFilter"
        >
          Show Filters
          <ShowFilter />
        </span>
      </Label>
    </Row>
  );
};

export default LifeInsuranceFilters;
